import React from 'react'
import styled from 'styled-components'

import { themeEstra } from 'src/styles/themeEstra'

import { BgRetina } from '../BgRetina'

interface Props {
  id?: string
  className?: string
  bgImage?: string
  bgImageMobile?: string
  bgPosition?: string
  spacerTop?: number
  spacerTopMobile?: number
  spacerBottom?: number
  spacerBottomMobile?: number
  paddingTop?: number
  paddingBottom?: number
  textAlign?: string
  bgSize?: string
}

const defaultIfNoValue = (defaultValue: number, value?: number): number => {
  if (value === null || value === undefined) {
    return defaultValue
  }
  return value
}

export const Base: React.FC<Props> = ({
  id,
  children,
  className,
  bgImage,
  bgImageMobile,
  bgPosition,
  spacerTop,
  spacerTopMobile,
  spacerBottom,
  spacerBottomMobile,
  paddingTop,
  paddingBottom,
  textAlign,
}) => {
  return (
    <Wrapper
      id={id}
      className={className}
      spacerTop={spacerTop}
      spacerTopMobile={spacerTopMobile}
      spacerBottom={spacerBottom}
      spacerBottomMobile={spacerBottomMobile}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
      bgImage={bgImage || ''}
      bgImageMobile={bgImageMobile}
      bgPosition={bgPosition || 'top center'}
      textAlign={textAlign || ''}
    >
      {children}
    </Wrapper>
  )
}

const Wrapper = styled(BgRetina)<Props>`
  margin-left: auto;
  margin-right: auto;
  padding-top: 3rem;
  padding-bottom: 3rem;
  background-position: ${props => props.bgPosition};
  text-align: ${prop => prop.textAlign};
  margin-top: ${prop => defaultIfNoValue(0, prop.spacerTopMobile)}rem;
  margin-bottom: ${prop => defaultIfNoValue(0, prop.spacerBottomMobile)}rem;
  @media (min-width: ${themeEstra.bp.tablet}) {
    margin-top: ${prop => defaultIfNoValue(0, prop.spacerTop)}rem;
    margin-bottom: ${prop => defaultIfNoValue(0, prop.spacerBottom)}rem;
    padding-top: ${prop => defaultIfNoValue(6, prop.paddingTop)}rem;
    padding-bottom: ${prop => defaultIfNoValue(6, prop.paddingBottom)}rem;
  }
`
